import logger from './logger';
import storage from './local-storage';

export default function convertUnit(value, from = 'lb', to = 'kg') {
  from = String(from).toLowerCase();
  to = String(to).toLowerCase();
  if (from === to) {
    return value;
  }
  const unit = ['kg', 'li', 'lt', 'l', 'gr', 'gm', 'g', 'ml', 'lb', 'oz', 'ga', 'gl', 'gal', 'ds', 'tn', 't', 'to'];
  const factor = [1, 1, 1, 1, .001, .001, .001, .001, .4535924, .029573529564111873, 3.785411784, 3.785411784, 3.785411784, .00061612, 907.18, 1000, 1000];
  const waterGalUnit = ['ga', 'gl', 'gal'];
  const waterWeightVolume = storage.getItem('waterWeightVolume');// 3.78
  const fromIndex = unit.indexOf(from);
  const sourceFactor = waterWeightVolume && waterGalUnit.includes(from) ? waterWeightVolume : factor[fromIndex];
  const toIndex = unit.indexOf(to);
  const targetFactor = waterWeightVolume && waterGalUnit.includes(to) ? waterWeightVolume : factor[toIndex];
  let result = value || 0;

  result = result * sourceFactor;
  result = result / targetFactor;

  if (isNaN(result)) {
    logger.warn(`Issue converting units, value: ${value} from: ${from} to: ${to}`);

    result = value;
  }

  return result;
}
